import React from "react";
import { Pencil } from "lucide-react";
import { Button } from "./ui/button";
import WeighmentSlipActions from "./WeighmentSlipActions";

export default function OutwardWeighmentReceiptActions({
  dispatchId,
  label,
  compact = false,
  onEdit,
  canEdit = false,
}) {
  const safeLabel = (label || `dispatch-${dispatchId}`).replace(/[/\\?%*:|"<>]/g, "-");

  const docActions = (
    <WeighmentSlipActions
      printPath={`/outward-dispatches/${dispatchId}/weighment-receipt/print`}
      pdfPath={`/outward-dispatches/${dispatchId}/weighment-receipt/pdf`}
      pdfFilenameBase={`outward-weighment-${safeLabel}`}
      opsKind="loading"
      compact={compact}
      testIdPrefix={`outward-weighment-${dispatchId}`}
      stopPropagation={compact}
    />
  );

  if (!compact || !canEdit || !onEdit) {
    return docActions;
  }

  return (
    <div className="flex items-center justify-end gap-0.5" onClick={(e) => e.stopPropagation()}>
      {docActions}
      <Button
        type="button"
        size="icon"
        variant="ghost"
        className="h-8 w-8 shrink-0 text-muted-foreground hover:text-foreground"
        onClick={(e) => {
          e.stopPropagation();
          onEdit();
        }}
        title="Edit weights"
        aria-label="Edit weights"
        data-testid={`edit-outward-weighment-${dispatchId}`}
      >
        <Pencil className="h-4 w-4" />
      </Button>
    </div>
  );
}
